import React from 'react';

function Process() {
  return (
    <section className="tc-process-style1">
      <div className="container">
        <div className="title mb-100 text-center">
          <h2 className="fsz-45"> What Our Clients Say </h2>
        </div>

        <div className="content">
          <div className="row">
            
            {/* LEFT CONTENT */}
            <div className="col-lg-5">
              <div className="info">
                <div
                  className="accordion wow fadeInUp slow"
                  id="accordionProcess"
                >

                  {/* ITEM 1 */}
                  <div className="accordion-item">
                    <div className="accordion-header" id="headingOne">
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                      >
                        <span className="num"> 1 / </span>
                        <h3> Management, Lady Wellingdon School </h3>
                      </button>
                    </div>

                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse show"
                      data-bs-parent="#accordionProcess"
                    >
                      <div className="accordion-body">
                        <div className="text">
                          "RED ANT STUDIO LLP transformed our vision for a modern, student-centric school building into a vibrant learning environment. 
                          Their team understood the heritage and purpose of Lady Willingdon and delivered a design that is functional, safe, and inspiring for our students. 
                          The project was executed with remarkable professionalism, clarity, and commitment."
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* ITEM 2 */}
                  <div className="accordion-item">
                    <div className="accordion-header" id="headingTwo">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                      >
                        <span className="num"> 2 / </span>
                        <h3> Local Community Representatives, Allikulam Lake</h3>
                      </button>
                    </div>

                    <div
                      id="collapseTwo"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionProcess"
                    >
                      <div className="accordion-body">
                        <div className="text">
                          "The rejuvenation of our community pond by RED ANT STUDIO LLP has restored both its ecological health and its cultural value. 
                          Their thoughtful design, sustainable approach, and hands-on coordination brought the space back to life. 
                          Today, the pond stands as a beautiful public asset, and we are deeply grateful for their impactful work."
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* ITEM 3 */}
                  <div className="accordion-item">
                    <div className="accordion-header" id="headingThree">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                      >
                        <span className="num"> 3 / </span>
                        <h3> Shivan Raj, School Principal, Valparai</h3>
                      </button>
                    </div>

                    <div
                      id="collapseThree"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionProcess"
                    >
                      <div className="accordion-body">
                        <div className="text">
                          "The complete renovation of all blocks in Valparai by RED ANT STUDIO LLP has brought new life to our campus. 
                          Their team carefully studied the unique climatic conditions of Valparai and delivered designs perfectly suited to its environment. 
                          Every block now feels modern, functional, and resilient, backed by their dedication, attention to detail, and seamless project coordination. 
                          We are truly grateful for their commitment to quality and community impact."
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            {/* RIGHT IMAGE FIX */}
            <div className="col-lg-4 offset-lg-2">
              <div
                className="img wow"
                style={{
                  transform: "none",       // 🔥 remove tilt
                  marginTop: "0px",        // 🔥 fix vertical shift
                }}
              >
                <img
                  src="/home1/assets/img/process.jpg"
                  alt=""
                  className="img-cover"
                  style={{
                    transform: "none",     // 🔥 ensure no rotation
                    borderRadius: "12px", // optional clean look
                  }}
                />
              </div>
            </div>

          </div>
        </div>
      </div>

      <img
        src="/home1/assets/img/c_line2.png"
        alt=""
        className="c-line wow"
      />
    </section>
  );
}

export default Process;